import { useEffect } from 'react';

const useCookieConsent = (consentGiven: boolean) => {
  useEffect(() => {
    localStorage.setItem('gaConsent', String(consentGiven));
  }, [consentGiven]);
};

export default useCookieConsent;
